import { AnyAction } from "redux";
import {
  BankDetails,
  CartItems,
  GET_CART_ITEMS_LIST_SUCCESS,
  GET_TRANSACTION_DATA,
  GET_TRANSACTION_DATA_SUCCESS,
  InvestorFundDetails,
  TransactionHistoryTable,
  TransactionType,
} from "../types";

interface CartState {
  transactionHistory: TransactionHistoryTable;
  fundDetails: InvestorFundDetails[];
  bankDetails: BankDetails[];
  cartItems: CartItems<TransactionType>;
}

const initialState: CartState = {
  bankDetails: [],
  fundDetails: [],
  transactionHistory: [],
  cartItems: [],
};

export function cartReducer(
  state = initialState,
  action: AnyAction
): CartState {
  switch (action.type) {
    case "GET_INVESTOR_DETAILS_SUCCESS": {
      const { Table14: fundDetails, Table7: bankDetails } = action.body;
      return {
        ...state,
        fundDetails: fundDetails.map((curr: any) => ({
          ...curr,
          CurValue: String(curr.CurValue.replace(/,/g, "")),
        })),
        bankDetails,
      };
    }
    case GET_TRANSACTION_DATA: {
      return { ...state, transactionHistory: [] };
    }
    case GET_TRANSACTION_DATA_SUCCESS: {
      const transactionHistory: TransactionHistoryTable = action.body;

      const historyTable = transactionHistory
        .sort(
          (t1, t2) =>
            new Date(t2.dco_updated_at).getTime() -
            new Date(t1.dco_updated_at).getTime()
        )
        .map((t) => ({
          ...t,
          dco_updated_at: new Date(t.dco_updated_at).toLocaleDateString(
            "en-IN",
            { month: "short", year: "numeric", day: "numeric" }
          ),
        }));

      return { ...state, transactionHistory: historyTable };
    }
    case GET_CART_ITEMS_LIST_SUCCESS: {
      return {
        ...state,
        cartItems: action.body.cartItems.map((cartItem: any) => ({
          ...cartItem,
          payload: JSON.parse(cartItem.payload),
        })),
      };
    }
    case "CLEAR_CART":
      return initialState;
    default:
      return state;
  }
}
